export default "__VITE_ASSET__CVQ64fxp__"